module.exports = __webpack_public_path__ + "static/assets/64bcfe1f13fce38e2ea26280157ff2ce.ttf";